import { getRequest } from 'utils/http'

export const getProgressCheck = () => {
  return getRequest('/stakeholders/progress-check')
}
